import { DEFAULT_PRIVACY_ID, DEFAULT_PRIVACY_URL, PRIVACY_FALLBACK_LOCALE } from '../Chat/Chat.constants';

const getFeatureName = (feature) => feature?.legalName || feature?.name;

const getFeatureUrl = (feature, locale = '') => {
  const { privacy } = feature || {};
  if (!privacy) return undefined;

  const [language] = locale.split('-');

  return (
    privacy[locale] ||
    Object.entries(privacy).find(([key]) => key.startsWith(`${language}-`))?.[1] ||
    privacy[PRIVACY_FALLBACK_LOCALE]
  );
};

export const getPrivacyPolicy = ({ chainId, features = {}, genericName, hotelId, isChain, language, locale } = {}) => {
  const feature = features?.[hotelId];
  const defaultUrl = `${DEFAULT_PRIVACY_URL}?idtokenprovider=${DEFAULT_PRIVACY_ID}${
    language ? `&language=${language}` : ''
  }`;

  const featureUrl = getFeatureUrl(feature, locale);
  const featureName = getFeatureName(feature);

  if (isChain && !featureUrl && !featureName) {
    const chainFeature = features?.[chainId];
    const chainName = chainFeature?.legalName;
    const chainUrl = getFeatureUrl(chainFeature, locale);

    if (chainName || chainUrl) return { name: chainName || genericName, url: chainUrl || defaultUrl };

    const hotelFeature = Object.values(features).find((item) => item?.legalName && getFeatureUrl(item, locale));

    if (hotelFeature) return { name: hotelFeature.legalName, url: getFeatureUrl(hotelFeature, locale) };

    return { name: genericName, url: defaultUrl };
  }

  if (featureUrl) return { name: featureName || genericName, url: featureUrl };

  return { name: featureName || genericName, url: defaultUrl };
};
